// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging,getToken,onMessage } from "firebase/messaging";
import notificationServices from "./notificationServices";

const firebaseConfig = {
  apiKey: "AIzaSyAK-3Jd1gsP9HWledOjtc0Iv-YPNODekJI",
  authDomain: "gtoken-n.firebaseapp.com",
  projectId: "gtoken-n",
  storageBucket: "gtoken-n.firebasestorage.app",
  messagingSenderId: "768630533772",
  appId: "1:768630533772:web:cb1b404367e1ef0c7695a9",
  measurementId: "G-QCGQE9N1GE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Messaging to app 
export const messaging = getMessaging(app);


export const generateFCMToken = async () => {
    const permission = await Notification.requestPermission();
    if(permission === "granted"){
        const fcmToken = await getToken(messaging,{
            vapidKey:"BNRbNbKo0EyqUx3l6BakX4MGtHoL4BkzXc8CuGUboALtclbpHB52xFr_jw5_KXINKIrxGeCEox_4rWyjYQVQTy4"
        })
        let phone = localStorage.getItem('customerPhone');
        if(phone && !sessionStorage.getItem('fcmRegistered')){
            let payload = {
                fcmToken: fcmToken,
                customerToken : localStorage.getItem("customerToken")
            }
            notificationServices.registerFcmToken(payload).then(res=>{
                sessionStorage.setItem("fcmRegistered",true);
            }).catch(error=>{
            })
        } else{
            //console.log("fcm alreday resistered")
        }   
    }   
}


onMessage(messaging, (payload) => {
    console.log('In-app message received:', payload);

    var audio = new Audio("/notification.mp3")
    audio.play();
    // Here you can handle how to display the message in your React UI
    // For example, update state to show a modal or banner component
    const { data } = payload;
    if (data) {
      // Display the notification title and body
      alert(`${data.title}\n${data.body}`);
      // Or use a more sophisticated UI component
    }
    // You can also access data payload if you included any in the console
    if (payload.data) {
      console.log('Message data:', payload);
      // Process any additional data here
    }
});
















/*

import { generateToken, messaging } from './global-whatsapp/notifications/firbase';
import { onMessage } from 'firebase/messaging';

useEffect(()=>{
    generateToken();
    onMessage(messaging,(payload)=>{
        console.log(payload);
    })
},[])

*/






/**   Origin validation file */

/*
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAK-3Jd1gsP9HWledOjtc0Iv-YPNODekJI",
  authDomain: "gtoken-n.firebaseapp.com",
  projectId: "gtoken-n",
  storageBucket: "gtoken-n.firebasestorage.app",
  messagingSenderId: "768630533772",
  appId: "1:768630533772:web:cb1b404367e1ef0c7695a9",
  measurementId: "G-QCGQE9N1GE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

*/